// Catalan content - complete translation matching the Spanish structure.
export const ca = {
  meta: { languageName: 'Català' },
  nav: {
    home: 'Inici',
    services: 'Serveis',
    cardio: 'Valoració cardiometabòlica estructurada',
    adiposity: 'Valoració d’adipositat i metabolisme',
    diabetes: 'Valoració integral de diabetis tipus 2',
    senior: 'Valoració Sènior Saludable',
    rehab: 'Rehabilitació funcional Sènior Saludable',
    family: 'Medicina de família VIDAT',
    about: 'Sobre VIDAT',
    book: 'Programar visita',
    cta: 'Apuntar-me a la llista',
  },
  brand: {
    name: 'VIDAT',
    tagline: 'Institut d’Intel·ligència Mèdica',
    location: 'Sant Cugat del Vallès',
  },
  seo: {
    '/': {
      title: 'Vidat | Medicina preventiva a Sant Cugat del Vallès',
      description: 'Centre privat de medicina preventiva a Sant Cugat. Valoracions mèdiques estructurades per entendre la teva salut i prendre decisions amb criteri.',
    },
    '/valoracion-cardiometabolica': {
      title: 'Valoració cardiometabòlica | Vidat, Sant Cugat',
      description: 'Valoració cardiometabòlica estructurada a Vidat (Sant Cugat). Analítica immediata, exploració clínica i pla preventiu per tenir cura del teu cor.',
    },
    '/valoracion-adiposidad-metabolismo': {
      title: 'Adipositat i metabolisme | Vidat, Sant Cugat',
      description: 'Valoració mèdica d’adipositat i salut metabòlica a Vidat (Sant Cugat). Una mirada integral més enllà de la bàscula amb resultats immediats clars.',
    },
    '/valoracion-diabetes-tipo-2': {
      title: 'Diabetis tipus 2 | Valoració integral | Vidat Sant Cugat',
      description: 'Valoració integral de diabetis tipus 2 a Vidat (Sant Cugat). Control metabòlic, tractament i pla preventiu en una mateixa consulta mèdica clara.',
    },
    '/senior-saludable': {
      title: 'Valoració Sènior Saludable | Vidat Sant Cugat',
      description: 'Valoració Sènior Saludable a Vidat (Sant Cugat). Visió mèdica integral de l’envelliment: prevenció funcional, cognitiva i cardiovascular activa.',
    },
    '/rehabilitacion-funcional': {
      title: 'Rehabilitació funcional Sènior | Vidat Sant Cugat',
      description: 'Rehabilitació funcional Sènior Saludable a Vidat (Sant Cugat). Recupera mobilitat, força i autonomia amb un pla mèdic totalment personalitzat.',
    },
    '/medicina-de-familia': {
      title: 'Medicina de família Vidat | Sant Cugat del Vallès',
      description: 'Medicina de família VIDAT a Sant Cugat del Vallès. Consulta mèdica propera, longitudinal i preventiva per acompanyar-te a cada etapa de la salut.',
    },
    '/sobre-vidat': {
      title: 'Sobre Vidat | Institut mèdic a Sant Cugat',
      description: 'Coneix VIDAT, institut d’intel·ligència mèdica a Sant Cugat. Medicina preventiva amb direcció clínica i de dades per a una atenció clara i rigorosa.',
    },
    '/programar-visita': {
      title: 'Programar visita | Vidat, Sant Cugat del Vallès',
      description: 'Apunta’t a la llista d’espera de Vidat (Sant Cugat) i t’avisarem quan obrim agenda de primeres valoracions de medicina preventiva personalitzada.',
    },
    '/politica-de-privacidad': {
      title: 'Política de privacitat | Vidat Sant Cugat',
      description: 'Política de privacitat de Vidat, institut mèdic a Sant Cugat. Informació sobre el tractament de dades personals i drets RGPD que tens com a usuari.',
    },
    '/politica-de-cookies': {
      title: 'Política de cookies | Vidat Sant Cugat',
      description: 'Política de cookies de Vidat (Sant Cugat). Informació sobre cookies pròpies i de tercers utilitzades al web i opcions de configuració disponibles.',
    },
    '/aviso-legal': {
      title: 'Avís legal | Vidat, Sant Cugat del Vallès',
      description: 'Avís legal de Vidat Institut d’Intel·ligència Mèdica, S.L. Informació corporativa, dades de contacte i condicions d’ús del lloc web vidat.cat.',
    },
  },
  buttons: {
    joinList: 'Apuntar-me a la llista',
    joinFirstAssessments: 'Apuntar-me a la llista de primeres valoracions',
    seeCardio: 'Veure valoració cardiometabòlica',
    seeAdiposity: 'Veure valoració d’adipositat i metabolisme',
    seeDiabetes: 'Veure valoració integral de diabetis tipus 2',
    expandInfo: 'Ampliar informació',
    expandRehab: 'Ampliar informació rehabilitació funcional',
    bookVisit: 'Programar visita',
  },
  form: {
    name: 'Nom',
    email: 'Correu electrònic',
    phone: 'Telèfon (opcional)',
    service: 'Servei d’interès',
    selectService: 'Seleccionar servei',
    submit: 'Apuntar-me a la llista',
    submitting: 'Enviant…',
    success: 'T’avisarem quan obrim agenda. Gràcies.',
    error: 'No s’ha pogut enviar la sol·licitud. Torna-ho a provar.',
    services: {
      cardio: 'Valoració Cardiometabòlica',
      adiposity: 'Valoració d’adipositat i metabolisme',
      diabetes: 'Valoració integral de diabetis tipus 2',
      senior: 'Valoració Sènior Saludable',
      rehab: 'Rehabilitació Funcional',
      family: 'Medicina de Família',
      undecided: 'Encara no ho tinc clar',
    },
  },
  location: {
    eyebrow: 'La nostra ubicació',
    title: 'Sant Cugat del Vallès',
    address: 'Local 6, Carrer de Pau Muñoz i Castanyer, 12, 08174 Sant Cugat del Vallès, Barcelona',
    description: 'Un entorn ben comunicat, pensat per facilitar l’accés a persones que valoren una atenció mèdica estructurada, eficient i sense desplaçaments innecessaris.',
    notify: 'T’avisarem quan obrim agenda per a les primeres valoracions.',
    homeIntro1: 'Som a Sant Cugat del Vallès.',
    homeIntro2: 'Pots consultar la ubicació del centre a Google Maps.',
    mapLabel: 'Veure a Google Maps',
    mapButton: 'Veure ubicació a Google Maps',
    placeholderExterior: 'Fotografia exterior de l’edifici (properament)',
    placeholderInterior: 'Fotografia de l’interior de VIDAT (properament)',
  },
  footer: {
    tagline: 'Medicina preventiva per entendre millor la teva salut.',
    sections: 'Serveis',
    institute: 'Institut',
    contact: 'Contacte',
    follow: 'Segueix-nos',
    rights: 'Tots els drets reservats.',
    notice: 'Comunicació sanitària amb caràcter informatiu. No constitueix consell mèdic individualitzat.',
  },
  home: {
    eyebrow: 'VIDAT — Institut d’Intel·ligència Mèdica',
    location: 'Sant Cugat del Vallès',
    headline: 'Medicina preventiva per entendre millor la teva salut i actuar amb criteri',
    intro1: 'A VIDAT realitzem valoracions mèdiques estructurades que integren dades clíniques, hàbits, exploració i resultats immediats per ajudar-te a comprendre la teva salut de forma clara i prendre millors decisions.',
    intro2: 'El nostre primer objectiu és que surtis de la consulta amb una visió ordenada de la teva situació, una explicació comprensible dels teus resultats i un pla d’acció inicial adaptat al teu cas.',
    differential: {
      eyebrow: 'Una manera diferent de treballar',
      title: 'Una manera més clara d’entendre la salut',
      p1: 'En moltes consultes, la informació es revisa de forma separada: una analítica per una banda, la tensió arterial per una altra, els antecedents en un altre moment i els hàbits de vida com una conversa aïllada.',
      p2: 'A VIDAT treballem d’una altra manera.',
      highlight: 'Integració clínica de totes les dades',
      p3: 'Integrem la informació clínica rellevant en una mateixa valoració per entendre quins factors tenen més pes, com es relacionen entre si i quines prioritats convé abordar primer.',
      p4: 'Això permet al metge dissenyar un pla d’acció amb totes les dades disponibles en la mateixa visita.',
      p5: 'No es tracta només d’obtenir dades.',
      p6: 'Es tracta d’interpretar-les en context i transformar-les en una orientació mèdica clara.',
    },
    cardioBlock: {
      eyebrow: 'Valoració cardiometabòlica estructurada',
      title: 'Comprèn el teu estat cardiovascular real en una sola visita',
      lead: 'Una avaluació mèdica completa per valorar i entendre el teu risc cardiometabòlic, fins i tot abans que apareguin símptomes.',
      audience: 'Està pensada per a persones que volen tenir una visió clara de la seva salut cardiovascular, especialment si tenen perfils d’alta responsabilitat, agendes exigents, antecedents familiars cardiovasculars, colesterol, glucosa o tensió en seguiment, o si busquen una prevenció més estructurada que una revisió aïllada.',
      includesTitle: 'Què inclou la valoració',
      includesIntro: 'Realitzem una valoració estructurada en un únic acte mèdic que inclou:',
      include1Title: 'Història clínica detallada',
      include1Body: 'hàbits, antecedents personals i familiars, medicació i factors de risc.',
      include2Title: 'Exploració clínica',
      include2Body: 'tensió arterial, composició corporal i mesures antropomètriques.',
      include3Title: 'Analítica immediata',
      include3Body: 'glucosa, perfil lipídic i hemoglobina glicada mitjançant mostra capil·lar.',
      processing: 'Tots els resultats es processen a la consulta mitjançant un sistema de Business Intelligence que permet visualitzar i relacionar els paràmetres de manera conjunta i en temps real.',
      processing2: 'Això permet interpretar els resultats en un context global, identificar els factors de més impacte i dissenyar un pla d’acció amb totes les dades disponibles en la mateixa visita.',
      modelEyebrow: 'Un model eficient de medicina preventiva',
      modelHighlight: 'Una sola visita per transformar dades clíniques disperses en resultats comprensibles i un pla d’acció personalitzat.',
      whatYouGetTitle: 'Què obtens en finalitzar',
      get1: 'Una visió clara i gràfica del teu risc cardiovascular.',
      get2: 'Comprensió dels factors específics que el determinen.',
      get3: 'Estimació del risc cardiovascular a 10 anys.',
      get4: 'Identificació de prioritats d’intervenció personalitzades.',
      get5: 'Un pla d’acció inicial explicat de forma estructurada i comprensible.',
    },
    seniorBridge: {
      eyebrow: 'I quan la preocupació no ets només tu',
      p1: 'Moltes persones comencen a tenir més cura de la seva salut just quan també comencen a preocupar-se per la salut dels seus pares.',
      p2: 'Quan una persona gran comença a perdre força, moure’s amb menys seguretat o mostrar canvis en la seva autonomia diària, pot ser un bon moment per fer una valoració mèdica i funcional més completa.',
      p3: 'Per això a VIDAT també hem desenvolupat la consulta Valoració Sènior Saludable.',
    },
    seniorBlock: {
      eyebrow: 'Valoració Sènior Saludable',
      title: 'Una valoració mèdica i funcional per cuidar autonomia, mobilitat i qualitat de vida',
      p1: 'La Valoració Sènior Saludable està pensada per a persones grans que necessiten una valoració global, ordenada i pràctica del seu estat de salut.',
      p2: 'Avaluem antecedents mèdics, medicació, independència en activitats diàries, mobilitat, equilibri, risc de caigudes, estat nutricional i cognició.',
      p3: 'L’objectiu és detectar àrees de fragilitat o vulnerabilitat de forma precoç i orientar un pla de cura personalitzat.',
      p4: 'Pot ser especialment útil quan notes que el teu pare, mare o avi comença a perdre força, es mou amb més inestabilitat, ha tingut alguna caiguda o presenta canvis en la seva alimentació. També quan necessiteu una valoració mèdica més completa per entendre millor com està i què convé fer.',
    },
    rehabBlock: {
      eyebrow: 'Rehabilitació funcional Sènior Saludable',
      p1: 'Quan la valoració ho indica, el següent pas pot ser treballar força, equilibri i mobilitat de forma supervisada.',
      p2: 'A VIDAT, la rehabilitació funcional pot fer-se de forma individual o en grups reduïts, segons les necessitats, el nivell funcional i els objectius de cada persona.',
      p3: 'Està pensada per a persones grans que necessiten moure’s amb més seguretat, recuperar confiança i mantenir independència en les activitats del dia a dia.',
      p4: 'Abans d’iniciar el programa, es realitza una valoració funcional prèvia per adaptar el treball al nivell de cada persona i definir si l’abordatge més adequat és individual, grupal o combinat.',
      p5: 'L’objectiu no és només fer exercici, sinó preservar autonomia, reduir vulnerabilitat funcional i acompanyar la persona gran en un procés segur i progressiu.',
    },
    twoMoments: {
      title: 'VIDAT neix per cuidar dos moments clau',
      moment1: 'Quan encara hi ets a temps de reduir riscos.',
      moment2: 'I quan mantenir l’autonomia comença a ser el més important.',
    },
  },
  cardio: {
    eyebrow: 'Valoració Cardiometabòlica Estructurada',
    title: 'Comprèn el teu estat cardiovascular real en una sola visita',
    lead: 'Una avaluació mèdica completa per valorar i entendre el teu risc cardiometabòlic, fins i tot abans que apareguin símptomes.',
    forWhomTitle: 'Per a qui és aquesta avaluació',
    forWhomLead: 'Adreçada a persones que volen tenir una visió clara de la seva salut cardiovascular:',
    forWhom: [
      'Persones amb perfils d’alta responsabilitat i agendes exigents que valoren l’eficiència.',
      'Persones amb antecedents familiars cardiovasculars.',
      'Pacients amb colesterol, glucosa o tensió en seguiment.',
      'Persones que busquen prevenció real, no només revisions aïllades.',
    ],
    problemTitle: 'El problema habitual',
    problemP1: 'En la pràctica clínica convencional, les dades s’obtenen de forma fragmentada: anàlisis per una banda, exploració per una altra i resultats en moments diferents, sense una visió global immediata.',
    problemP2: 'Això dificulta entendre el risc real en el moment de la consulta.',
    evalTitle: 'Avaluació completa en una sola visita',
    evalLead: 'Realitzem una valoració estructurada en un únic acte mèdic que inclou:',
    eval: [
      ['Història clínica detallada', 'hàbits, antecedents i factors de risc.'],
      ['Exploració clínica', 'tensió, composició corporal i mesures antropomètriques.'],
      ['Analítica immediata', 'glucosa, perfil lipídic i hemoglobina glicada mitjançant mostra capil·lar.'],
    ],
    integrationTitle: 'Integració clínica de totes les dades',
    integrationP1: 'Tots els resultats es processen a la consulta mitjançant un sistema de Business Intelligence que permet visualitzar i relacionar tots els paràmetres de manera conjunta i en temps real.',
    integrationP2: 'Això permet al metge:',
    integrationList: [
      'Interpretar els resultats en un context global i immediat.',
      'Identificar els factors de més impacte mitjançant la relació entre dades clíniques, analítiques i d’hàbits.',
      'Evitar la fragmentació d’informes i la pèrdua d’informació clau.',
      'Dissenyar un pla d’acció amb totes les dades disponibles en la mateixa visita.',
    ],
    interpretationTitle: 'Interpretació mèdica al moment',
    interpretationP1: 'L’avaluació és interpretada directament pel metge a través d’un dashboard interactiu durant la consulta.',
    interpretationP2: 'S’obté:',
    interpretationList: [
      'Estimació del risc cardiovascular a 10 anys.',
      'Comprensió clara de l’estat metabòlic actual.',
      'Identificació dels factors principals de risc mitjançant visualització de dades.',
      'Explicació estructurada, visual i comprensible per al pacient.',
    ],
    obtainTitle: 'Què obtens en finalitzar',
    obtain: [
      'Una visió clara i gràfica del teu risc cardiovascular.',
      'Comprensió dels factors específics que el determinen.',
      'Prioritats d’intervenció personalitzades i pla d’acció inicial.',
    ],
    modelEyebrow: 'Un model eficient de medicina preventiva',
    modelHighlight: 'Una sola visita per transformar dades clíniques disperses en resultats comprensibles i un pla d’acció personalitzat.',
  },
  senior: {
    eyebrow: 'Valoració Sènior Saludable',
    title: 'Una valoració mèdica i funcional per cuidar autonomia, mobilitat i qualitat de vida',
    lead: 'Una avaluació estructurada per conèixer l’estat funcional d’una persona gran, identificar àrees de vulnerabilitat i orientar un pla de cura personalitzat.',
    forWhomTitle: 'Per a qui és aquesta avaluació',
    forWhomLead: 'Adreçada a famílies que volen entendre millor l’estat funcional del seu pare, mare o avi, especialment quan apareixen canvis en la mobilitat, la força o l’autonomia diària.',
    forWhomIntro: 'Pot ser especialment útil quan:',
    forWhom: [
      'Una persona d’edat avançada comença a perdre força o moure’s amb més inestabilitat.',
      'Ha tingut alguna caiguda o té por de caure.',
      'Camina més lent o li costa aixecar-se d’una cadira.',
      'Ha reduït la seva activitat diària o surt menys de casa.',
      'Presenta pèrdua de pes, menys gana o canvis en la seva alimentació.',
      'La família necessita entendre millor la seva situació i saber què convé fer.',
    ],
    problemTitle: 'El problema habitual',
    problemP1: 'Sovint, els canvis en la mobilitat, la força o l’autonomia es produeixen de manera progressiva.',
    problemP2: 'Una mica menys de força, una mica més d’inseguretat en caminar, menys gana, una caiguda aïllada o més dificultat per fer activitats quotidianes poden semblar fets separats.',
    problemP3: 'Tanmateix, quan es valoren en conjunt, poden ajudar a detectar àrees de fragilitat o vulnerabilitat funcional que convé abordar a temps.',
    evalTitle: 'Avaluació mèdica i funcional en una sola visita',
    evalLead: 'Realitzem una valoració estructurada en un únic acte mèdic que inclou:',
    eval: [
      ['Història clínica i context personal', 'antecedents mèdics, medicació, caigudes recents, hàbits d’activitat, alimentació, convivència i xarxa de suport.'],
      ['Autonomia i funcionalitat', 'valoració d’independència en activitats bàsiques i instrumentals de la vida diària.'],
      ['Mobilitat, equilibri i força', 'proves funcionals per valorar la marxa, l’estabilitat, la força de membres inferiors i la força muscular global.'],
      ['Nutrició i cognició breu', 'cribratge nutricional, canvis de pes o gana, i valoració cognitiva breu quan procedeix.'],
    ],
    integrationTitle: 'Integració funcional de totes les dades',
    integrationP1: 'Tots els resultats s’analitzen de manera conjunta per entendre no només si existeix una limitació, sinó quines àrees estan conservades, quines comencen a mostrar vulnerabilitat i quines prioritats convé treballar primer.',
    integrationP2: 'Això permet al metge:',
    integrationList: [
      'Valorar l’estat d’autonomia, mobilitat, força, nutrició i cognició breu.',
      'Identificar risc de caigudes, fragilitat o pèrdua funcional incipient.',
      'Relacionar els resultats de les proves amb la situació real del dia a dia.',
      'Dissenyar un pla de treball adaptat al nivell funcional de cada persona.',
    ],
    interpretationTitle: 'Interpretació mèdica al moment',
    interpretationP1: 'L’avaluació és interpretada directament pel metge durant la consulta i s’explica de manera clara al pacient i, si escau, a la seva família.',
    interpretationP2: 'S’obté:',
    interpretationList: [
      'Classificació del perfil funcional actual.',
      'Valoració del risc de caigudes.',
      'Identificació d’àrees conservades i àrees vulnerables.',
      'Orientació sobre nutrició, força, mobilitat i autonomia.',
      'Recomanacions inicials i necessitat o no de seguiment.',
    ],
    obtainTitle: 'Què obtens en finalitzar',
    obtain: [
      'Una visió clara de l’estat funcional de la persona d’edat avançada.',
      'Comprensió de quins aspectes estan bé i quins convé vigilar.',
      'Identificació de prioritats de millora.',
      'Un pla de cura personalitzat, realista i adaptat a la seva situació.',
      'Orientació sobre si pot beneficiar-se de seguiment mèdic, suport nutricional o rehabilitació funcional.',
    ],
    modelEyebrow: 'Un model preventiu per envellir amb més autonomia',
    modelHighlight: 'Envellir bé no és només no tenir malalties. També és conservar força, mobilitat, equilibri, nutrició adequada, seguretat en caminar i capacitat per continuar fent les activitats importants de la vida diària.',
    modelOutro: 'La Valoració Sènior Saludable transforma informació mèdica i funcional dispersa en una explicació clara i un pla d’acció humà, progressiu i mesurable.',
    rehabTitle: 'Rehabilitació funcional i seguiment',
    rehabP1: 'Quan la valoració ho indica, el següent pas pot ser treballar força, equilibri i mobilitat de forma supervisada.',
    rehabP2: 'A VIDAT, la rehabilitació funcional pot fer-se de forma individual o en grups reduïts, segons les necessitats, el nivell funcional i els objectius de cada persona.',
    rehabP3: 'El seguiment pot incloure reavaluació funcional, seguiment nutricional o revisió mèdica evolutiva per ajustar el pla segons l’evolució.',
  },
  rehab: {
    eyebrow: 'Rehabilitació funcional individual i grupal',
    title: 'Força, equilibri i mobilitat per mantenir autonomia en el dia a dia',
    lead: 'Un programa d’exercici terapèutic supervisat, orientat a persones que necessiten millorar o mantenir la seva capacitat funcional, moure’s amb més seguretat i conservar independència en les seves activitats habituals.',
    lead2: 'Pot fer-se de forma individual o en grups reduïts, segons el nivell funcional, les necessitats clíniques i els objectius de cada persona.',
    forWhomTitle: 'Per a qui és aquest programa',
    forWhomLead: 'Adreçat a famílies que busquen una intervenció funcional estructurada per al seu pare, mare o avi.',
    forWhomIntro: 'Pot ser especialment útil quan:',
    forWhom: [
      'Comença a perdre força o moure’s amb més inseguretat.',
      'Li costa aixecar-se d’una cadira, caminar distàncies habituals o pujar escales.',
      'Ha tingut alguna caiguda o té por de caure.',
      'Camina més lent o ha reduït la seva activitat diària.',
      'Presenta prefragilitat, fragilitat lleu o pèrdua funcional incipient.',
      'Necessita recuperar confiança per moure’s amb més seguretat.',
    ],
    forWhomOutro: 'També pot estar indicat després d’una Valoració Sènior Saludable, quan s’identifiquen àrees de millora en força, equilibri, mobilitat, marxa o risc de caigudes.',
    problemTitle: 'El problema habitual',
    problemP1: 'Sovint, la pèrdua de mobilitat no apareix de cop.',
    problemP2: 'Comença amb petits canvis: caminar menys, aixecar-se amb més dificultat, evitar les escales, sentir-se insegur en sortir o necessitar més ajuda per a activitats que abans feia sense esforç.',
    problemP3: 'Si aquests canvis no es valoren ni es treballen de manera adequada, poden afavorir més sedentarisme, pèrdua de força i reducció progressiva d’autonomia.',
    problemP4: 'Per això, l’exercici terapèutic ha de ser segur, progressiu i adaptat al nivell real de cada persona.',
    valTitle: 'Valoració funcional abans de començar',
    valP1: 'Abans d’iniciar el programa, realitzem una valoració funcional inicial per conèixer el punt de partida i definir l’abordatge més adequat.',
    valP2: 'Aquesta valoració permet:',
    valList: [
      'Conèixer el nivell funcional: mobilitat, força, equilibri, marxa i tolerància a l’esforç.',
      'Identificar factors de risc: caigudes prèvies, por de caure, inestabilitat o ús d’ajudes tècniques.',
      'Assignar el format més adequat: intervenció individual, grup reduït o abordatge combinat.',
    ],
    valOutro: 'Les persones que hagin fet recentment la Valoració Sènior Saludable podran incorporar-se al programa sense repetir aquesta valoració inicial, sempre que no hagin aparegut canvis clínics rellevants.',
    adaptTitle: 'Un programa adaptat al nivell de cada persona',
    adaptP1: 'El programa no es planteja com una classe col·lectiva genèrica.',
    adaptP2: 'Cada persona s’hi incorpora segons la seva situació funcional, els seus objectius i la seva necessitat de supervisió.',
    adaptP3: 'Pot fer-se en dues modalitats:',
    adaptModes: [
      ['Rehabilitació funcional individual', 'indicada quan la persona necessita una supervisió més estreta, presenta més fragilitat, inseguretat, dolor, limitacions específiques o requereix un treball més personalitzat.'],
      ['Rehabilitació funcional en grups reduïts', 'indicada quan la persona pot beneficiar-se d’un entorn supervisat, motivador i adaptat, amb exercicis ajustats al seu nivell funcional.'],
    ],
    adaptOutro: 'Els grups són reduïts per permetre una atenció propera, progressió segura i adaptació individual dins de cada sessió.',
    workTitle: 'Què es treballa durant les sessions',
    workP1: 'Les sessions combinen exercici terapèutic multicomponent, guiat per fisioterapeuta, amb treball de força, equilibri, mobilitat, marxa i resistència funcional.',
    workP2: 'Inclouen:',
    workList: [
      ['Força funcional', 'aixecar-se i seure, treball de cames, tronc i braços amb exercicis adaptats.'],
      ['Equilibri i seguretat', 'canvis de pes, estabilitat, control postural, girs i suport segur.'],
      ['Marxa i mobilitat', 'caminar amb més seguretat, canviar de direcció, millorar ritme, tolerància i confiança.'],
      ['Resistència funcional', 'exercicis de baixa càrrega per millorar la tolerància a l’esforç.'],
      ['Moviments útils per a la vida diària', 'aixecar-se, girar, pujar un esglaó, abastar objectes o desplaçar-se amb més seguretat.'],
    ],
    workHighlight: 'L’objectiu no és fer exercici sense més, sinó entrenar capacitats directament relacionades amb l’autonomia quotidiana.',
    followTitle: 'Seguiment de l’evolució',
    followP1: 'El programa s’organitza en cicles de treball, amb seguiment de l’evolució funcional mitjançant proves senzilles i comparables en el temps.',
    followP2: 'Això permet:',
    followList: [
      'Valorar canvis en força, mobilitat, equilibri i marxa.',
      'Ajustar la intensitat i el tipus d’exercicis.',
      'Revisar si el grup o modalitat continua sent el més adequat.',
      'Detectar noves necessitats de seguiment mèdic, nutricional o funcional.',
    ],
    followOutro: 'L’evolució no es basa només en sensacions. S’acompanya d’indicadors funcionals que ajuden a entendre si la persona millora, es manté o necessita ajustar el pla.',
    obtainTitle: 'Què obtens en iniciar el programa',
    obtain: [
      'Una valoració funcional inicial per conèixer el punt de partida.',
      'Un pla de treball adaptat al nivell funcional de la persona.',
      'Sessions supervisades per fisioterapeuta.',
      'Treball específic de força, equilibri, mobilitat i marxa.',
      'Seguiment de l’evolució funcional.',
      'Orientació sobre la modalitat més adequada: individual, grupal o combinada.',
    ],
    modelTitle: 'Un model funcional, segur i mesurable',
    modelP1: 'La rehabilitació funcional de VIDAT està pensada per acompanyar persones que volen mantenir autonomia, moure’s amb més seguretat i preservar la seva capacitat per fer les activitats importants de la vida diària.',
    modelP2: 'Una intervenció estructurada per transformar la pèrdua de força, la inseguretat en caminar o la reducció d’activitat en un pla de treball progressiu, supervisat i adaptat a cada persona.',
    integratedTitle: 'Integrat dins de l’enfocament Sènior Saludable',
    integratedP1: 'Aquest programa pot ser el següent pas després de la Valoració Sènior Saludable, especialment quan es detecten àrees de millora en mobilitat, força, equilibri o risc de caigudes.',
    integratedP2: 'També pot iniciar-se de forma independent, sempre amb una valoració funcional prèvia que permeti treballar amb seguretat i adaptar el programa des del primer dia.',
  },
  family: {
    eyebrow: 'Medicina de Família VIDAT',
    title: 'Una consulta mèdica propera, resolutiva i amb visió global',
    lead: 'Atenció mèdica per valorar símptomes, revisar problemes de salut freqüents, interpretar resultats i orientar decisions clíniques amb criteri.',
    lead2: 'A VIDAT, la medicina de família no es planteja com una visita ràpida i aïllada, sinó com una consulta estructurada per entendre el context complet de cada persona.',
    forWhomTitle: 'Per a qui és aquesta consulta',
    forWhomLead: 'Adreçada a persones que busquen una atenció mèdica clara, eficient i de confiança.',
    forWhomIntro: 'Pot ser especialment útil per a:',
    forWhom: [
      'Persones amb agendes exigents que necessiten una valoració mèdica resolutiva.',
      'Pacients que volen consultar símptomes recents o persistents.',
      'Persones que necessiten interpretar resultats, informes o recomanacions prèvies.',
      'Pacients que busquen una segona mirada clínica abans de decidir els següents passos.',
      'Persones que volen una consulta mèdica general amb més temps, ordre i continuïtat.',
    ],
    problemTitle: 'El problema habitual',
    problemP1: 'En moltes ocasions, l’atenció mèdica es viu de forma fragmentada.',
    problemP2: 'Una consulta per un símptoma, una altra per una analítica, una altra per una recepta, una altra per una derivació. Sovint, el pacient acaba acumulant informes, resultats i recomanacions sense una visió mèdica suficientment integrada.',
    problemP3: 'Això pot dificultar entendre què és prioritari, què pot esperar, què requereix seguiment i quines decisions convé prendre.',
    consultTitle: 'Consulta mèdica amb visió integral',
    consultP1: 'Realitzem una valoració mèdica orientada a comprendre el motiu de consulta i el context general de salut.',
    consultP2: 'La consulta pot incloure:',
    consultList: [
      ['Valoració clínica del problema actual', 'símptomes, evolució, antecedents rellevants i exploració dirigida.'],
      ['Revisió d’informació mèdica disponible', 'informes, analítiques, proves prèvies, tractaments i recomanacions rebudes.'],
      ['Orientació diagnòstica i pla inicial', 'recomanacions, ajust de tractament quan procedeix, sol·licitud de proves o derivació si és necessari.'],
    ],
    consultOutro: 'L’objectiu és que la persona entengui què està passant, quin nivell d’importància té i quins són els següents passos raonables.',
    integrationTitle: 'Integració clínica de la informació',
    integrationP1: 'A VIDAT donem importància a revisar la informació mèdica de forma ordenada.',
    integrationP2: 'Això permet al metge:',
    integrationList: [
      'Interpretar símptomes, informes i resultats dins del context global de la persona.',
      'Diferenciar problemes urgents, importants i situacions que es poden seguir de forma programada.',
      'Evitar decisions basades en dades aïllades.',
      'Dissenyar un pla de seguiment clar i adaptat al cas.',
    ],
    integrationOutro: 'La consulta no se centra només a resoldre un dubte puntual, sinó a entendre com aquest dubte encaixa dins de la salut general del pacient.',
    followTitle: 'Seguiment mèdic i continuïtat',
    followP1: 'La medicina de família permet acompanyar problemes freqüents de salut de forma longitudinal.',
    followP2: 'Pot incloure:',
    followList: [
      'Valoració de símptomes recents o persistents.',
      'Revisió i ajust de tractaments quan procedeix.',
      'Interpretació d’informes, analítiques o proves complementàries.',
      'Seguiment de problemes mèdics habituals.',
      'Coordinació amb altres especialistes si és necessari.',
      'Orientació sobre quan observar, quan tractar i quan ampliar estudi.',
    ],
    followOutro: 'La continuïtat permet detectar canvis, ordenar decisions i mantenir una visió més completa de l’evolució clínica.',
    obtainTitle: 'Què obtens en finalitzar',
    obtain: [
      'Una valoració mèdica clara del motiu de consulta.',
      'Explicació comprensible dels resultats i informes disponibles.',
      'Orientació sobre el nivell d’importància del problema.',
      'Recomanacions inicials i pla d’actuació.',
      'Indicació de proves, seguiment o derivació si procedeix.',
      'Una visió mèdica global, no només una resposta aïllada.',
    ],
    modelEyebrow: 'Una medicina de família pensada per a persones que valoren el seu temps',
    modelP1: 'Una consulta per entendre millor què passa, ordenar la informació mèdica disponible i definir els següents passos amb criteri clínic.',
    modelP2: 'Atenció mèdica propera, estructurada i resolutiva per a qui busca confiança, claredat i continuïtat.',
  },
  about: {
    eyebrow: 'Sobre VIDAT',
    title: 'Un projecte mèdic construït des de la clínica, la gestió i les dades',
    p1: 'VIDAT neix com un centre de medicina preventiva orientat a oferir valoracions mèdiques més estructurades, comprensibles i útils per al pacient.',
    p2: 'El nostre enfocament combina experiència clínica, anàlisi de dades, organització assistencial i una manera clara de comunicar els resultats.',
    p3: 'L’objectiu és que cada persona entengui millor la seva situació de salut i pugui prendre decisions amb una orientació mèdica clara, realista i personalitzada.',
    teamEyebrow: 'Equip fundador',
    team: [
      {
        name: 'Dra. Inés Betancourt Torres',
        role: 'Direcció mèdica',
        bio: [
          'Metgessa especialista via MIR en Medicina Familiar i Comunitària, amb més de 14 anys d’experiència mèdica i formació específica en diabetis tipus 2, prevenció cardiometabòlica, atenció a la cronicitat, geriatria i innovació sanitària.',
          'Compta amb un Màster en Atenció i Educació a les Persones amb Diabetis per la Universidad Francisco de Vitoria i la Fundació redGDPS, formació especialment alineada amb la valoració cardiometabòlica, el seguiment de factors de risc i l’educació sanitària del pacient.',
          'Ha desenvolupat la seva activitat assistencial en atenció primària, consulta privada a Sant Cugat del Vallès, urgències hospitalàries, telemedicina i geriatria.',
          'En l’àmbit de l’envelliment saludable, compta amb experiència en valoració geriàtrica integral, seguiment de pacients amb comorbiditat, ortogeriatria i continuïtat assistencial; competències directament relacionades amb la Valoració Sènior Saludable i els programes funcionals de VIDAT.',
          'També ha realitzat formació de postgrau com a Experta en Productes Sanitaris per la Universitat de Barcelona i ha participat com a cofundadora i directora mèdica de Clarity Stethoscope.',
          'A VIDAT lidera el disseny clínic de les valoracions mèdiques, l’atenció assistencial i la coordinació del model preventiu del centre, integrant medicina de família, prevenció cardiometabòlica i envelliment saludable.',
        ],
      },
      {
        name: 'Jacqueline Torres Castillo',
        role: 'Direcció d’administració, operacions i experiència del centre',
        bio: [
          'Administradora d’empreses, amb formació complementària en disseny i gestió administrativa, i experiència en direcció executiva, desenvolupament de projectes i organització d’iniciatives empresarials.',
          'Ha estat CEO de Clarity Stethoscope, una startup d’innovació mèdica en patologia respiratòria desenvolupada a Barcelona, orientada a millorar el seguiment de malalties respiratòries mitjançant tecnologia accessible i fiable. Des d’aquesta posició, ha participat en la coordinació estratègica i operativa d’un projecte healthtech amb component clínic, tecnològic, científic i de comunicació.',
          'Durant la seva etapa a Clarity Stethoscope, el projecte va participar en programes, acceleradores, congressos i espais d’innovació sanitària, i va obtenir diferents reconeixements vinculats a l’ecosistema emprenedor i de salut digital a Catalunya. Aquesta experiència li ha permès treballar en àrees clau per a VIDAT: direcció de projecte, gestió de recursos, relació amb col·laboradors, comunicació, desenvolupament de marca i organització operativa.',
          'A VIDAT coordina l’àrea administrativa, l’experiència del pacient i el funcionament intern del centre.',
          'El seu paper és garantir que cada procés —des del primer contacte fins a l’atenció en consulta— sigui clar, ordenat i coherent amb la filosofia de VIDAT: una medicina estructurada, propera i eficient.',
        ],
      },
      {
        name: 'Patricia Peña Torres',
        role: 'Direcció de dades, visualització clínica i innovació tecnològica',
        bio: [
          'Científica de dades i consultora en Business Intelligence, amb formació en sociologia, intel·ligència de negoci i gestió de dades.',
          'La seva experiència professional s’ha desenvolupat en anàlisi d’informació, processos ETL, reporting, visualització de dades, definició d’indicadors i construcció de solucions analítiques per donar suport a la presa de decisions.',
          'Ha estat CTO de Clarity Stethoscope, projecte healthtech orientat a l’anàlisi de sons respiratoris i al desenvolupament d’eines digitals per millorar el seguiment clínic de pacients respiratoris. En aquest context ha participat en el disseny tecnològic del projecte, l’estructuració de dades clíniques i el desenvolupament de models d’anàlisi aplicats a senyals biomèdiques.',
          'També ha participat en investigació aplicada en salut digital, incloent-hi treballs presentats a l’European Respiratory Society International Congress, amb publicacions sobre classificació de sons respiratoris mitjançant algoritmes de machine learning.',
          'A VIDAT lidera l’àrea de dades, visualització clínica i suport tecnològic.',
          'El seu treball permet reforçar un dels elements diferencials del centre: convertir dades clíniques, hàbits, exploració i resultats immediats en una visió integrada, visual i comprensible durant la consulta.',
        ],
      },
    ],
    collabTitle: 'Equip clínic col·laborador',
    collabP1: 'VIDAT incorporarà progressivament professionals sanitaris col·laboradors alineats amb l’enfocament del centre.',
    collabP2: 'L’objectiu és comptar amb un equip clínic coordinat, capaç d’acompanyar diferents àrees de prevenció, seguiment i cura funcional.',
    collabIntro: 'Entre els perfils previstos s’inclouen:',
    collabList: [
      'Metges col·laboradors.',
      'Fisioterapeutes.',
      'Nutricionistes.',
      'Psicòlegs.',
      'Altres professionals sanitaris vinculats a la cura preventiva i funcional.',
    ],
    collabOutro: 'Tots els col·laboradors treballaran sota una mateixa filosofia: valoració estructurada, comunicació clara, seguiment personalitzat i coordinació clínica quan sigui necessari.',
    methodTitle: 'La nostra manera de treballar',
    methodP1: 'A VIDAT creiem que una bona atenció mèdica no depèn només de fer més proves, sinó d’integrar millor la informació.',
    methodP2: 'Per això treballem amb una metodologia basada en:',
    methodList: [
      'Escolta clínica i valoració mèdica rigorosa.',
      'Recollida estructurada d’informació.',
      'Interpretació de dades en context.',
      'Explicació clara de resultats.',
      'Plans d’acció realistes i mesurables.',
      'Coordinació entre professionals quan el cas ho requereix.',
    ],
    methodOutro: 'VIDAT és un centre pensat per a persones que valoren una medicina clara, ordenada i orientada a decisions.',
    visionTitle: 'Una clínica amb una visió pròpia',
    visionP1: 'VIDAT uneix tres àrees que habitualment treballen per separat: medicina, dades i gestió.',
    visionP2: 'La direcció mèdica aporta el criteri clínic i la visió assistencial.',
    visionP3: 'La direcció de dades permet transformar informació complexa en resultats comprensibles.',
    visionP4: 'La direcció administrativa i operativa garanteix una experiència organitzada, eficient i coherent amb el nivell d’atenció que volem oferir.',
    visionP5: 'El resultat és un model de centre mèdic pensat perquè el pacient no només rebi informació, sinó que pugui entendre-la i utilitzar-la per cuidar millor la seva salut.',
  },
  book: {
    eyebrow: 'Programar visita',
    title: 'Llista d’espera de primeres valoracions',
    p1: 'VIDAT obrirà properament a Sant Cugat del Vallès. De moment pots apuntar-te a la llista d’espera i t’avisarem quan obrim agenda per a les primeres valoracions.',
    p2: 'Indica’ns quin servei t’interessa i, si vols, un telèfon de contacte. Tractarem la teva informació amb confidencialitat.',
  },
  adiposity: {
    eyebrow: 'Valoració d’adipositat i metabolisme',
    title: 'Valoració d’adipositat i metabolisme',
    lead: 'Una valoració mèdica estructurada per comprendre el pes, l’adipositat i la salut metabòlica des d’una visió clínica global.',
    homeShortTitle: 'Valoració d’adipositat i metabolisme',
    homeShortLead: 'Una valoració mèdica per comprendre el pes, l’adipositat abdominal i els factors metabòlics que poden influir en la salut.',
    homeShortP1: 'A VIDAT analitzem el pes dins d’un context clínic més ampli: antecedents, tractaments, hàbits d’alimentació, activitat física, esfera emocional, possibles factors hormonals i paràmetres metabòlics immediats.',
    homeShortP2: 'L’objectiu és identificar quines àrees poden estar influint en la salut metabòlica i orientar un pla inicial realista, personalitzat i mesurable.',
    forWhomTitle: 'Per a qui és aquesta valoració',
    forWhomP1: 'Adreçada a persones amb sobrepès, obesitat, augment progressiu de pes, perímetre abdominal elevat o dificultat per millorar la seva composició corporal i la seva salut metabòlica.',
    forWhomP2: 'També pot ser útil quan hi ha alteracions de glucosa, colesterol o triglicèrids, antecedents familiars cardiometabòlics, dolor crònic que limita l’activitat física, tractaments que poden afavorir l’augment de pes o sospita de factors hormonals associats.',
    problemTitle: 'El problema habitual',
    problemP1: 'Sovint, el pes s’aborda de manera aïllada, centrant l’atenció només en la dieta o en la bàscula.',
    problemP2: 'A VIDAT el valorem de forma més completa, integrant informació clínica, hàbits, exploració física i paràmetres metabòlics per entendre quins factors poden estar influint i quines prioritats convé abordar primer.',
    includesTitle: 'Què inclou la valoració',
    includesIntro: 'Fem una valoració mèdica estructurada que pot incloure:',
    includesList: [
      'Història clínica, antecedents i tractaments habituals.',
      'Revisió d’hàbits d’alimentació, activitat física i context personal.',
      'Valoració de possibles factors hormonals, digestius, emocionals o funcionals.',
      'Exploració clínica i antropomètrica: pes, talla, tensió arterial i circumferència abdominal.',
      'Analítica immediata a consulta: glucosa, perfil lipídic i hemoglobina glicosilada.',
      'Interpretació visual de resultats i resum d’àrees prioritàries.',
    ],
    obtainTitle: 'Què obtens en finalitzar',
    obtainList: [
      'Una visió mèdica clara de la teva situació metabòlica.',
      'Comprensió dels factors que poden estar influint en el pes.',
      'Resultats immediats de paràmetres metabòlics clau.',
      'Identificació d’àrees prioritàries de millora.',
      'Un pla inicial personalitzat, realista i mesurable.',
      'Orientació sobre seguiment mèdic, nutricional, psicològic, hormonal o funcional si escau.',
    ],
    closingTitle: 'Una mirada més enllà de la bàscula',
    closingP1: 'Comprendre l’adipositat implica mirar més enllà de la bàscula: valorar-ne la distribució, el context metabòlic i els factors clínics que poden estar influint.',
    closingP2: 'La Valoració d’adipositat i metabolisme de VIDAT ajuda a ordenar aquesta informació i convertir-la en una orientació mèdica clara, realista i personalitzada.',
  },
  diabetes: {
    eyebrow: 'Valoració integral de diabetis tipus 2',
    title: 'Valoració integral de diabetis tipus 2',
    lead: 'Una consulta mèdica estructurada per revisar el control metabòlic, el tractament i el pla preventiu en diabetis tipus 2.',
    homeShortTitle: 'Valoració integral de diabetis tipus 2',
    homeShortLead: 'Una consulta mèdica estructurada per revisar el control metabòlic, el tractament actual i els controls preventius recomanats en diabetis tipus 2.',
    homeShortP1: 'Integrem dades clíniques, hàbits, exploració, resultats immediats i factors de risc cardiovascular per oferir una visió més clara de la situació actual.',
    homeShortP2: 'L’objectiu és ajudar el pacient a entendre millor la seva diabetis, ordenar prioritats clíniques i definir un pla de seguiment adaptat al seu perfil.',
    forWhomTitle: 'Per a qui és aquesta valoració',
    forWhomP1: 'Adreçada a persones amb diabetis tipus 2, prediabetis o alteracions de la glucosa que volen comprendre millor la seva situació actual i revisar el seu pla de seguiment.',
    forWhomP2: 'Pot ser especialment útil si hi ha un diagnòstic recent, dubtes sobre el control metabòlic, necessitat de revisar el tractament, presència d’altres factors de risc cardiovascular o interès a ordenar els controls preventius recomanats.',
    problemTitle: 'El problema habitual',
    problemP1: 'La diabetis tipus 2 no es resumeix en una xifra de glucosa o hemoglobina glicosilada.',
    problemP2: 'També es relaciona amb el pes, la pressió arterial, el perfil lipídic, la funció renal, el risc cardiovascular, els hàbits de vida, l’adherència al tractament i els cribratges preventius.',
    problemP3: 'Per això, a VIDAT fem una valoració estructurada que integra tots aquests elements en una mateixa consulta.',
    includesTitle: 'Què inclou la valoració',
    includesIntro: 'La valoració parteix de la metodologia cardiometabòlica de VIDAT, adaptada a les necessitats específiques de la diabetis tipus 2.',
    includesIntro2: 'Pot incloure:',
    includesList: [
      'Història clínica, evolució de la diabetis i antecedents rellevants.',
      'Revisió del tractament actual, adherència i tolerància.',
      'Exploració clínica: tensió arterial, pes, perímetre abdominal i valoració dirigida.',
      'Analítica immediata: glucosa, perfil lipídic i hemoglobina glicosilada.',
      'Valoració de microalbuminúria en orina i creatinina quan escaigui.',
      'Revisió d’hàbits d’alimentació, activitat física i altres factors de control metabòlic.',
      'Orientació sobre controls preventius recomanats segons el perfil de risc.',
    ],
    obtainTitle: 'Què obtens en finalitzar',
    obtainList: [
      'Una valoració clara de l’estat actual de la diabetis tipus 2.',
      'Resultats immediats de paràmetres metabòlics clau.',
      'Revisió del tractament i de possibles àrees d’ajust segons criteri mèdic.',
      'Valoració del risc cardiovascular associat.',
      'Orientació sobre cribratges preventius: funció renal, fons d’ull, podologia, ECG i analítiques habituals quan escaigui.',
      'Un pla inicial de seguiment personalitzat i comprensible.',
    ],
    closingTitle: 'Seguiment, educació i decisions individualitzades',
    closingP1: 'La diabetis tipus 2 requereix seguiment, educació sanitària i decisions individualitzades.',
    closingP2: 'La Valoració integral de diabetis tipus 2 de VIDAT permet ordenar la informació clínica, revisar el control metabòlic i definir prioritats de seguiment amb una visió mèdica global.',
  },
};
